// 🪀 SLL — Lenis smooth scroll drop-killer
// Desactivado en touch. Expone singleton window.DRP_LENIS para pause/resume.

import Lenis from 'lenis'
import { SCR } from '../📺SCR/📺SCR.js'

export let SLL = null

export function initSLL() {
  if (SCR.touch) return null  // en touch dejamos scroll nativo

  SLL = new Lenis({
    wheelEventsTarget: document.documentElement,
    lerp: .1,
    wheelMultiplier: .4,
    smoothWheel: true,
    smoothTouch: false,
    normalizeWheel: true,
  })

  const raf = (t) => {
    SLL.raf(t)
    requestAnimationFrame(raf)
  }
  requestAnimationFrame(raf)

  window.DRP_LENIS = SLL
  return SLL
}
